import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import type Item from 'owa-service/lib/contract/Item';
import preserveItemDataInCache from 'owa-mail-store/lib/utils/preserveItemDataInCache';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Adds/Updates the meeting message items in store with the freshly received GetItems response
 * @param items items received in GetItems call response
 * @param itemIds id of the items whose details are requested in GetItems call
 */
export const parseGetItemsResponse = mutatorAction('parseGetItemsResponse', (items: Item[]) => {
    const { meetingMessageItems } = getListViewStore();
    items.forEach(responseItem => {
        const itemId = responseItem.ItemId?.Id;
        meetingMessageItems.has(itemId) &&
            preserveItemDataInCache(responseItem, meetingMessageItems.get(itemId));
        meetingMessageItems.set(itemId, responseItem as ClientItem);
    });
});
